export default "__VITE_ASSET__ad2668fd__"